import * as Yup from 'yup';
import messages from './messages';

export const ForgotPasswordSchema = Yup.object().shape({
  email: Yup.string()
    .email(messages.emailInvalid.id)
    .required(messages.emailRequired.id),
});
